var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fcd559",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4585 4430 c-11 -5 -625 -614 -1365 -1354 l-1345 -1346 -665 665 c-628 627 -667 665 -700 665 -33 0 -53 -18 -273 -238 -202 -202 -237 -242 -237 -267 0 -26 116 -146 907 -938 500 -500 921 -915 937 -923 22 -12 34 -13 55 -4 15 6 746 729 1624 1608 1399 1400 1597 1601 1597 1627 0 25 -35 64 -237 266 -131 131 -247 240 -258 242 -11 3 -29 2 -40 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.eff652eb8844aaab210360f8a7a8b960.svg";
export { ForwardRef as ReactComponent };